module.exports = __webpack_public_path__ + "img/23.0094dc3b.png";